import { useSearchParams } from "react-router-dom";
//import React, {useEffect} from "react";
import Metadata from "../components/metadata/MetaData";

import bottleImage from "../assets/amritjal/bottle.jpg";
import facebookIcon from "../assets/amritjal/Facebook.png";
import instagramIcon from "../assets/amritjal/Instagram.png";
import twitterIcon from "../assets/amritjal/Twitter.png";
import youtubeIcon from "../assets/amritjal/YouTube.png";
import satisfactionSeal from "../assets/amritjal/4501657hio.png";
import dharmikLogo from "../assets/amritjal/Vector.png";

const Amritjal = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    
    return (
      <div style={{ fontFamily: "Arial, sans-serif", margin: 0, padding: 0 }}>
        <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
       />
        
        <div style={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          textAlign: "center", 
          padding: "20px", 
          position: "relative",
          maxWidth: "100vw",
          overflow: "hidden"
        }}>
          <a href="/" style={{ 
            position: "absolute", 
            top: "14px", 
            left: "20px", 
            zIndex: 10
          }}>
            <img src={dharmikLogo} alt="Dharmik Logo" style={{ 
              width: "60px", 
              height: "auto",
              "@media (max-width: 480px)": {
                width: "40px"
              }
            }} />
          </a>
         
          <div style={{ 
            position: "relative", 
            width: "100%", 
            maxWidth: "500px",
            margin: "0 auto",
            padding: "0 15px"
          }}>
            <img 
              src={bottleImage} 
              alt="Bottle Background" 
              style={{ 
                marginTop: "50px", 
                width: "100%", 
                height: "auto",
                maxWidth: "100%"
              }} 
            />
            <div style={{ 
              position: "absolute", 
              top: "64%", 
              left: "50%", 
              transform: "translate(-50%, -50%)", 
              padding: "15px", 
              borderRadius: "8px", 
              width: "90%",
              maxWidth: "400px"
            }}>
              <h2 style={{ 
                fontSize: window.innerWidth <= 480 ? "1rem" : "1.2rem",
                color: "#00796b", 
                marginBottom: "10px" 
              }}>
                It took nature and divinity centuries to bless this Amrit Jal.
              </h2>
              <h2 style={{ 
                fontSize: window.innerWidth <= 480 ? "0.9rem" : "1.2rem",
                color: "#333" 
              }}>
                Experience the sacred purity of Ganga Jal, collected from the holy Triveni Sangam at Mahakumbh 2025.
              </h2>
            </div>
          </div>
  
          <div style={{ 
            marginTop: "20px", 
            color: "#000000", 
            fontSize: window.innerWidth <= 480 ? "1.5rem" : "2rem",
            fontWeight: "500",
            padding: "0 15px",
            wordBreak: "break-word"
          }}>
            Container ID: {id || '0012'}
          </div>
  
          <div style={{ 
            display: "flex", 
            justifyContent: "center", 
            gap: window.innerWidth <= 480 ? "15px" : "20px",
            marginTop: "20px", 
            flexWrap: "wrap",
            padding: "0 15px"
          }}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <img src={facebookIcon} alt="Facebook" style={{ 
                width: window.innerWidth <= 480 ? "30px" : "35px",
                height: window.innerWidth <= 480 ? "30px" : "35px",
                transition: "transform 0.3s ease" 
              }} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <img src={instagramIcon} alt="Instagram" style={{ width: "35px", height: "35px", transition: "transform 0.3s ease" }} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src={twitterIcon} alt="Twitter" style={{ width: "35px", height: "35px", transition: "transform 0.3s ease" }} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <img src={youtubeIcon} alt="YouTube" style={{ width: "35px", height: "35px", transition: "transform 0.3s ease" }} />
            </a>
          </div>
  
          <img 
            src={satisfactionSeal} 
            alt="100% Satisfaction Guaranteed" 
            style={{ 
              position: "absolute", 
              bottom: "25px", 
              right: "12px", 
              width: window.innerWidth <= 480 ? "60px" : "81px",
              height: "auto" 
            }} 
          />
        </div>
  
      </div>
    );
  };
  
  export default Amritjal;
  
  